import {NgIf} from '@angular/common';
import {Component, Input, OnInit, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {Router, RouterLink} from '@angular/router';
import {CustomizerSettingsService} from "../../../customizer-settings/customizer-settings.service";
import {ApiService} from "../../_services/api.service";
import {Endpoints} from "../../endpoints";
import {NgxSpinnerService} from "ngx-spinner";
import {LoggerService} from "../../_services/logger.service";
import {DialogService} from "../../_modal/dialog.service";
import {finalize, of, tap} from "rxjs";
import {catchError} from "rxjs/operators";
import {environment} from "../../../../environments/environment";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";

@Component({
    selector: 'app-samples',
    standalone: true,
    providers: [ApiService, Endpoints, DialogService],
    imports: [
        MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
        MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
        MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect
    ],
    templateUrl: './samples.component.html',
    styleUrl: './samples.component.scss'
})
export class SamplesComponent  implements OnInit{
    @Input() samples: any[] = [];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    editForm: FormGroup;
    dataSource = new MatTableDataSource<PeriodicElement>();

    displayedColumns: string[] = ['collected_by', 'collection_date', 'comments', 'creation_date', 'sample_code ', 'sample_type', 'source', 'storage_conditions', 'action'];
    constructor(
        private apiService: ApiService,
        private endpoints: Endpoints,
        private spinner: NgxSpinnerService,
        private loggerService: LoggerService,
        private dialogService: DialogService,
        private router: Router,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private overlayContainer: OverlayContainer) {
        this.initializeEditForm();
    }
    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }

    viewSampleDetails(sampleId: number) {
        this.router.navigate(['/samples', sampleId]);
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes['samples']) {
            this.dataSource.data = this.samples;
        }
    }

    ngAfterViewInit() {
        this.initializePaginatorAndSort();
        const overlayContainerElement = this.overlayContainer.getContainerElement();
        overlayContainerElement.style.zIndex = '2000';
    }

    initializePaginatorAndSort(){
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';
    }

    initializeEditForm() {
        this.editForm = this.fb.group({
            id: [''],
            collected_by: ['', Validators.required],
            collection_date: ['', Validators.required],
            comments: ['', Validators.required],
            creation_date: ['', Validators.required],
            sample_code : [''],
            sample_type: ['', [Validators.required]],
            source: [''],
            storage_conditions: [''],
            update_date: ['', Validators.required],
            created_by: ['', Validators.required],
            flag: ['', Validators.required],
        });
    }

    openEditModal(element: any) {
        this.editForm.patchValue(element);
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    }

    onEditSubmit(modal: any) {
        if (this.editForm.valid) {
            this.spinner.show();
            const formData = this.editForm.value;
            this.apiService.put(formData, this.endpoints.sample_base_endpoint, formData.id,).pipe(
                tap((response: any) => {
                    if (response.status) {
                        let sample = response.data;
                        sample = {
                            id: sample.id,
                            collected_by: sample.collected_by,
                            collection_date: sample.collection_date,
                            comments: sample.comments,
                            creation_date: sample.creation_date,
                            sample_code : sample.sample_code ,
                            sample_type: sample.sample_type,
                            source: sample.source,
                            storage_conditions: sample.storage_conditions,
                            update_date: sample.update_date,
                            created_by: sample.created_by,
                            action: {
                                edit: 'edit',
                                delete: 'delete'
                            }
                        };
                        this.updateTableRow(sample);
                        this.modalService.dismissAll();
                        this.dialogService.openSuceessAlert('Sample Updated Successfully' );
                    }
                }),
                catchError((error: { status: number }) => {
                    this.spinner.hide();
                    this.loggerService.log('error', error);
                    if (error.status === 401) {
                        this.dialogService.open('Token Expired. Redirecting to Login Page', environment.error_message_type, 'danger', environment.error_icon);
                        setTimeout(() => {
                            this.router.navigate(['/authentication']);
                        }, 3000)
                    } else if (error.status === 500) {
                        this.dialogService.open('Internal Server Error!!!', environment.error_message_type, 'danger', environment.error_icon);
                    } else {
                        this.dialogService.open('Bad Request. Please Check Your Input and Submit Again!', environment.error_message_type, 'danger', environment.error_icon);
                    }

                    return of(null);  // Handle the error appropriately
                }),
                finalize(() => {
                    this.spinner.hide();
                    this.initializePaginatorAndSort();
                })
            ).subscribe();

        } else {
            this.loggerService.log('invalid_form_data', this.editForm.value);
            this.dialogService.open('Form is invalid. Please check the fields.', environment.error_message_type, 'danger', environment.error_icon);

        }
    }

    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
            this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
        }
    }

    confirmDelete(element: any) {
        this.dialogService.open("Êtes-vous sûr de vouloir supprimer cet échantillon ?", environment.warning_message_type, 'danger', environment.warning_icon, true)
            .then((result: any) => {
                if (result) {
                    this.deleteSample(element.id);
                }
            });
    }

    deleteSample(id: number) {
        this.spinner.show();
        this.apiService.delete(id, this.endpoints.sample_base_endpoint).pipe(
            tap((response: any) => {
                if (response.status) {
                    this.removeTableRow(id);
                    this.dialogService.openSuceessAlert('Échantillon supprimé avec succès' );
                }
            }),
            catchError((error: { status: number }) => {
                this.spinner.hide();
                this.loggerService.log('error', error);
                if (error.status === 401) {
                    this.dialogService.open('Token Expired. Redirecting to Login Page', environment.error_message_type, 'danger', environment.error_icon);
                    setTimeout(() => {
                        this.router.navigate(['/authentication']);
                    }, 3000)
                } else if (error.status === 500) {
                    this.dialogService.open('Internal Server Error!!!', environment.error_message_type, 'danger', environment.error_icon);
                } else {
                    this.dialogService.open('Cannot be deleted. Contact with Admin', environment.error_message_type, 'danger', environment.error_icon);
                }

                return of(null);  // Handle the error appropriately
            }),
            finalize(() => {
                this.spinner.hide();
                this.dataSource.paginator = this.paginator;
            })
        ).subscribe();
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    onIdentificationClick(element: any) {
        // Logique à exécuter lors du clic sur l'collected_by
        //this.dialogService.open('Identification clicked:'+ element.id, environment.error_message_type, 'danger', environment.error_icon);
        // Vous pouvez rediriger ou ouvrir un modal ici
        this.router.navigate(['/manage-fermes', element.id]);

    }
}

interface PeriodicElement {
    id: number;
    collected_by: string;
    collection_date: string;
    comments: string;
    creation_date: string;
    sample_code : string;
    sample_type: string;
    source: string;
    storage_conditions: string;
    update_date: string;
    created_by: string;
    flag: number;
    action: any;
}
